import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TMECheckinAnalysis from "./tme-checkin-analysis/TMECheckinAnalysis";
import TMECheckinBreakdown from "./tme-checkin-analysis/TMECheckinBreakdown";
import TMECheckinAnalysisLogs from "./tme-checkin-analysis/TMECheckinAnalysisLogs";
import TMEAttendanceKeyInsights from "./tme-checkin-analysis/TMEAttendanceKeyInsights";
import CmnFilters from "../../lead-management/common/CmnFilters";
import {
  currentMonthName,
  currentMonthNumber,
} from "../../common-data/Converts";
import {
  fetchTMECheckinAnalysisData,
  fetchTMECheckinBreakdownData,
  fetchTMECheckinTimelineData,
} from "../../../redux/prospect-reducers/prospectSlice";

const TMEAttendanceAnalysis = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const {
    tmeCheckinAnalysisLoading,
    tmeCheckinBreakdownLoading,
    tmeCheckinTimelineLoading,
  } = useSelector((state) => state.prospects);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: "2025",
      value: 2025,
    },
    isActive: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: rowData?.user_id || "",
    // gym_id: rowData?.gym_id || "",
    // trainer_id: rowData?.trainer_id || "",
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
    checkin_status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
    setFilters(iniFilters);
  };

  const getCheckinAnalysisData = (filters) => {
    const { page, limit, ...rest } = filters || {};

    dispatch(
      fetchTMECheckinAnalysisData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  };

  const getCheckinBreakdownData = (filters) => {
    const { page, limit, ...rest } = filters || {};

    dispatch(
      fetchTMECheckinBreakdownData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  };

  const getCheckinTimelineData = (filters) => {
    dispatch(
      fetchTMECheckinTimelineData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  function getCombineReload() {
    getCheckinAnalysisData(filters);
    getCheckinBreakdownData(filters);
    getCheckinTimelineData(filters);
  }

  useEffect(() => {
    getCheckinAnalysisData(filters);
  }, [filters.month, filters.year, filters.checkin_status]);

  useEffect(() => {
    getCheckinBreakdownData(filters);
  }, [filters.month, filters.year, filters.checkin_status]);

  useEffect(() => {
    getCheckinTimelineData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
      checkin_status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedMonth,
    allFilters.selectedYear,
    allFilters.isActive,
  ]);

  return (
    <>
      <CmnFilters
        from="tme-attendance-analysis"
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        isLoading={
          tmeCheckinAnalysisLoading ||
          tmeCheckinBreakdownLoading ||
          tmeCheckinTimelineLoading
        }
        isReload={getCombineReload}
      />

      <TMECheckinAnalysis
        userInfoData={userInfoData}
        rowData={rowData}
        filters={filters}
      />

      <TMECheckinBreakdown
        callFunction={() => getCheckinBreakdownData(filters)}
      />

      <TMECheckinAnalysisLogs
        // isPage={isPage}
        // setIsPage={setIsPage}
        // pageLimit={pageLimit}
        // setPageLimit={setPageLimit}
        callFunction={() => getCheckinTimelineData(filters)}
      />

      <TMEAttendanceKeyInsights
        callFunction={() => getCheckinAnalysisData(filters)}
      />
    </>
  );
};

export default TMEAttendanceAnalysis;
